// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c430eeb0","453":"d5a67b36","732":"cfe7db3f","977":"4397af84"}[chunkId] + ".chunk.js";
};